module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"hr":{"homeLinkTitle":"Početna stranica"},"en":{"homeLinkTitle":"Home page"}}')
  delete Component.options._Ctor
}
